import Apis from '@/Apis/_'
import { Anestesista } from '@/types/_'
import ResponseApi from '../interfaces/FactoryResponse'
import { CoreBase, ICoreBase } from './CoreBase'

class PreAnestesia extends CoreBase implements IPreAnestesia {
  async anestesistaSolicitaCancelamento(solicitacaoId: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.anestesistaSolicitaCancelamento(solicitacaoId)
    return response
  }

  async anestesistaFazAvaliacao(anestesista: Anestesista): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.anestesistaFazAvaliacao(anestesista)
    return response
  }
}

interface IPreAnestesia extends ICoreBase {
  anestesistaSolicitaCancelamento(solicitacaoId: string): Promise<ResponseApi>
  anestesistaFazAvaliacao(anestesista: Anestesista): Promise<ResponseApi>
}

export {
  PreAnestesia,
  IPreAnestesia,
}
